module.exports = __webpack_public_path__ + "img/cars.1df15d9f.png";